// @flow
import { StackActions } from '@react-navigation/native';
import IdentityRequirements from './IdentityRequirements.container';
import { withProps } from 'react-recompose';
import Navigation from '../../../lib/navigation';

const withNavigationProps = () => ({
  goToPassportCheck: () => Navigation.dispatch(StackActions.push('passportCheck')),
  goToConfirmPersonalInfo: (isEditing: boolean = false) =>
    Navigation.dispatch(StackActions.push('confirmPersonalInfo', { isManuallyEditing: isEditing })),
});

export default withProps(withNavigationProps)(IdentityRequirements);
